export const DynamicLoaderStatuses = {
  Failed: 'Loading Failed',
  Loaded: 'Loaded',
} as const;

export type DynamicLoaderStatuses = (typeof DynamicLoaderStatuses)[keyof typeof DynamicLoaderStatuses];
